import { render, staticRenderFns } from "./ButtonDeleteItem.vue?vue&type=template&id=07419f40&"
import script from "./ButtonDeleteItem.vue?vue&type=script&lang=js&"
export * from "./ButtonDeleteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07419f40')) {
      api.createRecord('07419f40', component.options)
    } else {
      api.reload('07419f40', component.options)
    }
    module.hot.accept("./ButtonDeleteItem.vue?vue&type=template&id=07419f40&", function () {
      api.rerender('07419f40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/ButtonDeleteItem.vue"
export default component.exports